/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import React from 'react';
import Icon from '@ant-design/icons';

function EmptySvg() {
  return (
    <svg
      width="106"
      height="64"
      viewBox="0 0 106 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.8"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.2831 11.9903C22.3731 8.6089 23.3875 6.50362 24.3246 5.6736C26.9198 3.37634 30.5079 4.6266 31.2708 4.80567C33.9506 5.43645 33.0793 1.28557 35.3785 0.441846C36.9107 -0.12037 38.1709 0.566872 39.1598 2.50357C40.0353 0.696739 41.3694 -0.130856 43.1623 0.0167557C45.852 0.24019 46.7932 9.15418 50.4891 7.20296C54.1857 5.25093 58.7176 4.80487 60.6535 7.70548C61.0719 8.33304 61.2322 7.35944 64.0781 4.03535C66.9239 0.710451 69.7616 -0.754376 75.5832 1.18152C78.2302 2.06074 80.4069 4.44431 82.1159 8.33142C82.1159 13.8794 86.2754 17.1639 94.5927 18.1827C107.07 19.7113 97.3851 32.8745 82.1159 36.7294C66.8458 40.585 31.69 42.6661 12.6123 32.9254C-0.106144 26.4328 2.78412 19.4539 21.2823 11.9903H21.2831Z"
        fill="url(#paint0_linear_1006_34135)"
      />
      <path
        d="M52.5697 61.0168C65.2756 61.0168 75.5759 58.6773 75.5759 55.7915C75.5759 52.9056 65.2756 50.5662 52.5697 50.5662C39.8637 50.5662 29.5635 52.9056 29.5635 55.7915C29.5635 58.6773 39.8637 61.0168 52.5697 61.0168Z"
        fill="url(#paint1_linear_1006_34135)"
      />
      <path
        opacity="0.675"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M91.4106 62.3113C74.1126 66.5687 15.0686 61.6991 8.78415 59.4752C5.72537 58.3919 2.96828 56.3552 0.51369 53.3642C0.238967 53.0298 0.0662864 52.6259 0.0156024 52.1993C-0.0350816 51.7726 0.0382997 51.3406 0.227267 50.9531C0.416234 50.5656 0.713073 50.2385 1.08348 50.0096C1.45389 49.7807 1.88276 49.6593 2.32051 49.6594H105.497C107.638 55.2558 102.943 59.4728 91.4106 62.3113Z"
        fill="url(#paint2_linear_1006_34135)"
      />
      <path
        d="M70.2237 41.7878L62.356 32.7601C62.1699 32.5447 61.9387 32.3713 61.6781 32.2515C61.4175 32.1318 61.1337 32.0687 60.8459 32.0664H43.9285C43.3482 32.0664 42.7966 32.3278 42.4184 32.7601L34.5508 41.7878V46.7437H70.2237V41.7878Z"
        fill="url(#paint3_linear_1006_34135)"
      />
      <path
        d="M67.9943 46.9261L61.1082 39.0631C60.9417 38.8775 60.7365 38.7292 60.5064 38.6283C60.2763 38.5273 60.0268 38.4762 59.7748 38.4783H44.9996C44.4925 38.4783 43.9968 38.6848 43.6663 39.0631L36.7802 46.9261V51.2448H67.9943V46.9261Z"
        fill="url(#paint4_linear_1006_34135)"
      />
      <path
        d="M70.2236 52.4231C70.2236 53.1111 69.908 53.7298 69.4098 54.1444L69.3087 54.2251C68.9137 54.5188 68.4315 54.6775 67.9359 54.6768H36.8393C36.5582 54.6768 36.2894 54.6268 36.0411 54.5348L35.9178 54.4864C35.511 54.3088 35.1654 54.0193 34.9228 53.653C34.6802 53.2867 34.5509 52.8592 34.5508 52.4223V41.8418H43.2059C44.162 41.8418 44.9322 42.6137 44.9322 43.5502V43.5623C44.9322 44.4996 45.7115 45.2554 46.6675 45.2554H58.1069C58.5664 45.255 59.0071 45.0759 59.3323 44.7574C59.6576 44.4388 59.8409 44.0068 59.8422 43.5559C59.8422 42.6153 60.6133 41.8418 61.5685 41.8418H70.2245L70.2236 52.4231Z"
        fill="url(#paint5_linear_1006_34135)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1006_34135"
          x1="54.8144"
          y1="29.8047"
          x2="54.8144"
          y2="-7.04462"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DEDEDE" stopOpacity="0" />
          <stop offset="1" stopColor="#A9A9A9" stopOpacity="0.3" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1006_34135"
          x1="50.1724"
          y1="61.0168"
          x2="50.1724"
          y2="50.5662"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#96A1C5" stopOpacity="0.373" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1006_34135"
          x1="53"
          y1="63.9999"
          x2="53"
          y2="46.8379"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#919191" stopOpacity="0.15" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1006_34135"
          x1="52.3872"
          y1="32.0664"
          x2="52.3872"
          y2="38.6639"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A361FF" />
          <stop offset="1" stopColor="#722ED1" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_1006_34135"
          x1="56.5528"
          y1="51.2448"
          x2="56.5528"
          y2="37.7996"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EFDBFF" />
          <stop offset="1" stopColor="#EFDBFF" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_1006_34135"
          x1="52.3876"
          y1="41.8418"
          x2="52.3876"
          y2="54.6768"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A361FF" />
          <stop offset="1" stopColor="#ECDFFF" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default function EmptyImage(props: { style?: React.CSSProperties }) {
  return <Icon component={EmptySvg} {...props} />;
}
